import { render, staticRenderFns } from "./TagListing.vue?vue&type=template&id=59f41af0&scoped=true&"
import script from "./TagListing.vue?vue&type=script&lang=js&"
export * from "./TagListing.vue?vue&type=script&lang=js&"
import style0 from "./TagListing.vue?vue&type=style&index=0&id=59f41af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f41af0",
  null
  
)

export default component.exports